import { useField } from 'formik';
import { forwardRef } from 'react';

import { Field, FieldError, FieldLabel } from '@ui/components/base/field';
import { RichTextEditor, type RichTextEditorHandle } from '@ui/components/editor/RichTextEditor';

interface FormikRichTextEditorProps {
  name: string;
  label?: string;
  required?: boolean;
  className?: string;
}

const FormikRichTextEditor = forwardRef<RichTextEditorHandle, FormikRichTextEditorProps>(
  ({ name, label, required, className }, ref) => {
    const [field, meta, helpers] = useField<string>(name);

    const hasError = Boolean(meta.touched && meta.error);

    return (
      <Field>
        {label && (
          <FieldLabel>
            {label}
            {required && ' *'}
          </FieldLabel>
        )}
        <RichTextEditor
          ref={ref}
          className={className}
          value={field.value ?? ''}
          onChange={(html) => {
            helpers.setValue(html);
            helpers.setTouched(true);
          }}
        />
        {hasError && <FieldError>{meta.error}</FieldError>}
      </Field>
    );
  }
);
FormikRichTextEditor.displayName = 'FormikRichTextEditor';

export { FormikRichTextEditor };
export type { FormikRichTextEditorProps };
